import $ from "jquery";

const MAX_COLLAPSIBLE_CONTENT_LENGTH = 30;

class CollapsibleContent extends HTMLElement {
    constructor() {
        super();
        this.isCollapsed = true;
        this.toggleContent = this.toggleContent.bind(this);
    }

    connectedCallback() {
        this.maxLength =
            parseInt(this.getAttribute("max-length")) || MAX_COLLAPSIBLE_CONTENT_LENGTH;
        this.moreText = this.getAttribute("more-text") || "Zobraziť viac";
        this.lessText = this.getAttribute("less-text") || "Zobraziť menej";
        this.mobileOnly = this.hasAttribute("mobile-only");

        this.originalContent = this.innerHTML;
        this.render();

        this.querySelector("button").addEventListener("click", this.toggleContent);
    }

    toggleContent() {
        this.isCollapsed = !this.isCollapsed;
        this.updateContent();

        this.scrollToContent();
    }

    scrollToContent() {
        const contentElement = this.querySelector(".collapsible-content__content");
        if (!contentElement) {
            return;
        }
        const scrollToElement = contentElement.closest(".c-product-tab");
        if (scrollToElement) {
            const yOffset = -80;
            const yPosition =
                scrollToElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: yPosition, behavior: "smooth" });
        }
    }

    render() {
        this.innerHTML = `
            <div class="collapsible-content ${this.isCollapsed ? "collapsed" : "expanded"} ${this.mobileOnly ? "mobile-only" : ""}">
                <div class="collapsible-content__content">
                    ${this.originalContent}
                    <div class="collapsible-content__overlay"></div>
                </div>
                <button class="collapsible-content__button c-link c-link--primary">
                    <span class="collapsible-content__button-text">
                        ${this.isCollapsed ? this.moreText : this.lessText}
                    </span>
                   <span class="collapsible-content__button-icon">
                        <i class="ico ico-chevron-up" aria-hidden="true"></i>
                   </span>
                </button>
            </div>
        `;
        this.updateContent();
    }

    updateContent() {
        const $contentElement = $(this.querySelector(".collapsible-content__content"));
        const $buttonTextElement = $(this.querySelector(".collapsible-content__button-text"));
        const $buttonIconElement = $(this.querySelector(".collapsible-content__button-icon"));
        const $collapsibleContentElement = $(this.querySelector(".collapsible-content"));

        if (this.isCollapsed) {
            $collapsibleContentElement.removeClass("expanded");
            $buttonTextElement.text(this.moreText);
            $buttonIconElement.html('<i class="ico ico-chevron-down" aria-hidden="true"></i>');
            $contentElement.css("max-height", `${this.maxLength}em`);
        } else {
            $collapsibleContentElement.addClass("expanded");
            $buttonTextElement.text(this.lessText);
            $buttonIconElement.html('<i class="ico ico-chevron-up" aria-hidden="true"></i>');
            $contentElement.css("max-height", $contentElement[0].scrollHeight + "px");
        }
    }
}

customElements.define("collapsible-content", CollapsibleContent);

export default CollapsibleContent;
